import { put, select, takeLatest, delay, call } from 'redux-saga/effects';
import { DateTime } from 'luxon';

import { getEnvironmentConfig, crashReporterInterface } from 'companion-app-components/utils/core';
import { authActions, authSelectors } from 'companion-app-components/flux/auth';
import { entitlementsActions, entitlementsSelectors } from 'companion-app-components/flux/entitlements';
import { datasetsSelectors, datasetsActions } from 'companion-app-components/flux/datasets';

function* redirectUserToQuickenSubscription(entitlement) {
  const entitlements = yield select(entitlementsSelectors.getEntitlements);
  const activeEntitlements = yield select(entitlementsSelectors.getActiveEntitlements);
  const localTime = DateTime.local();
  crashReporterInterface.reportError(Error('no active entitlement found'), (event) => event.addMetadata('custom', {
    entitlement,
    activeEntitlements,
    entitlements,
    localTime,
  }));
  yield put(authActions.authLogout({ reason: 'AUTH_LOGOUT_UNAUTHORIZED' }, { context: 'no entitlement quicken' }));
  window.location.replace(getEnvironmentConfig()?.pick_your_plan_url ?? '');
}

export function* getEntitlementsSuccessActionWatcher() {
  yield takeLatest([datasetsActions.getDatasetEntitlementsSuccess, 
    entitlementsActions.getEntitlementsSuccess], function* getEntitlementsSuccess(action) {
    yield delay(3000);
    const datasets = yield select(datasetsSelectors.getEntitledDatasets);
    if (action.type === entitlementsActions.getEntitlementsSuccess.type) {
      const userEntitlement = yield select(entitlementsSelectors.getTopTierEntitlement);
      const sharedDatasets = datasets.filter((objDataset) => objDataset.shared);
      if (!userEntitlement && 
        ((datasets.size > 0 && sharedDatasets.size === 0) || datasets.size === 0)) {
        yield call(redirectUserToQuickenSubscription, userEntitlement);
      }
    } else {
      const currentDatasetId = yield select(authSelectors.getDatasetId);
      const selectedDataset = currentDatasetId ? datasets.find(({ id }) => id === currentDatasetId) : undefined;
      const entitlement = selectedDataset?.entitlements;
      const entitledDatasetsLoadPending = yield select(datasetsSelectors.getEntitledDatasetsLoadPending);

      if (!entitlement && !entitledDatasetsLoadPending) {
        yield call(redirectUserToQuickenSubscription, entitlement);
      }
    }
  });
}

export default [
  getEntitlementsSuccessActionWatcher,
];
